import {SearchFactory} from "../../search/services/search-factory";
import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {RelatedEntitiesResponseApiModel} from "../models/related-entities-response-api-model";

export class RelatedEntitiesFactory extends SearchFactory {
  createResponse(apiModel, request: BaseApiRequestParams){
    return new RelatedEntitiesResponseApiModel(apiModel, request);
  }
}